import { TypedDocumentNode, gql } from '@apollo/client';

import { BodyS } from '@sorare/core/src/atoms/typography';

import {
  ItemImgContainer,
  ItemInfosContainer,
  ItemPropertiesContainer,
} from 'components/ItemPreview/ui';
import { ItemRoot } from 'components/mySorare/common/ui';
import { CardDescription } from 'components/token/CardDescription';

import { Bundle } from '../Bundle';
import { AuctionDetails } from './AuctionDetails';
import { AuctionImg } from './AuctionImg';
import type { Auction_auction } from './__generated__/index.graphql';

type Props = {
  auction: Auction_auction;
};

export const Auction = ({ auction }: Props) => {
  return (
    <ItemRoot>
      <ItemImgContainer>
        <AuctionImg auction={auction} />
      </ItemImgContainer>
      <ItemInfosContainer>
        {auction.cards.length > 1 && (
          <ItemPropertiesContainer>
            <Bundle />
          </ItemPropertiesContainer>
        )}
        {auction.cards.length === 1 && (
          <CardDescription
            card={auction.cards[0]}
            Details={BodyS}
            detailsColor="var(--c-nd-600)"
          />
        )}
        <AuctionDetails auction={auction} isDesktopLayout={false} />
      </ItemInfosContainer>
    </ItemRoot>
  );
};

Auction.fragments = {
  auction: gql`
    fragment Auction_auction on TokenAuction {
      id
      cards: anyCards {
        slug
        ...CardDescription_anyCard
      }
      ...AuctionImg_auction
      ...AuctionDetails_auction
    }
    ${AuctionImg.fragments.auction}
    ${AuctionDetails.fragments.auction}
    ${CardDescription.fragments.anyCard}
  ` as TypedDocumentNode<Auction_auction>,
};
